export function setupAccordions() {
    const accordions = document.querySelectorAll('.accordion-set');
    const multipleCanBeOpen = false; // Set true if multiple panels can be open at once
    const sliderSpeed = 575; // Speed of slider in milliseconds
    if (typeof setupAccordions.isInitialized === 'undefined') { // Check if the function has been initialized before 
        setupAccordions.isInitialized = true;
    }

    accordions.forEach((accordionSet, a) => {
        const accordionItems = accordionSet.children;
        Array.from(accordionItems).forEach((accordion, b) => {
            const header = accordion.querySelector('.accordion-header');
            const panel = accordion.querySelector('div');
            if (!header || !panel) return; // Ensure header and panel exist

            panel.style.display = 'none';

            // Create unique code to set aria identification to each accordion
            const code = `${a + 1}-${b + 1}`;
            header.id = `acc-header-${code}`;
            header.setAttribute('aria-controls', `acc-panel-${code}`);
            panel.id = `acc-panel-${code}`;
            panel.setAttribute('aria-labelledby', `acc-header-${code}`);

            // Set click and keyboard controls on accordion headers
            const icon = document.createElement('i');
            icon.className = 'fa fa-chevron-down';
            header.appendChild(icon);

            header.addEventListener('click', (evt) => toggleAccordion(evt, accordion, accordionSet, multipleCanBeOpen, sliderSpeed));
            header.addEventListener('keydown', (evt) => handleAccordionKeydown(evt, accordion, accordionSet, multipleCanBeOpen, sliderSpeed));
        });

        // Open any accordions where the header button has the "open-by-default" class
        const openByDefault = accordionSet.querySelector('.open-by-default');
        if (openByDefault) {
            openByDefault.click();
        }
    });
}

function toggleAccordion(evt, accordion, accordionSet, multipleCanBeOpen, sliderSpeed) {
    const header = evt.currentTarget;
    const panel = header.parentElement.nextElementSibling;

    if (accordion.classList.contains('opened')) {
        header.setAttribute('aria-expanded', 'false');
        slideUp(panel, sliderSpeed);
        accordion.classList.remove('opened');
    } else {
        if (!multipleCanBeOpen) {
            const openedAccordions = accordionSet.querySelectorAll('.opened');
            openedAccordions.forEach((openedAccordion) => {
                const openedHeader = openedAccordion.querySelector('.accordion-header');
                const openedPanel = openedAccordion.querySelector('div');
                if (openedHeader && openedPanel) {
                    openedHeader.setAttribute('aria-expanded', 'false');
                    openedAccordion.classList.remove('opened');
                    slideUp(openedPanel, sliderSpeed);
                }
            });
        }

        header.setAttribute('aria-expanded', 'true');
        accordion.classList.add('opened');
        slideDown(panel, sliderSpeed);
    }
}

function handleAccordionKeydown(evt, accordion, accordionSet, multipleCanBeOpen, sliderSpeed) {
    const accordionItems = Array.from(accordionSet.children);
    const index = accordionItems.indexOf(accordion);

    switch (evt.key) {
        case 'Enter':
        case ' ':
            evt.preventDefault();
            toggleAccordion(evt, accordion, accordionSet, multipleCanBeOpen, sliderSpeed);
            break;
        case 'ArrowUp':
            evt.preventDefault();
            if (index > 0) {
                accordionItems[index - 1].querySelector('.accordion-header').focus();
            }
            break;
        case 'ArrowDown':
            evt.preventDefault();
            if (index < accordionItems.length - 1) {
                accordionItems[index + 1].querySelector('.accordion-header').focus();
            }
            break;
        case 'Home':
            evt.preventDefault();
            accordionItems[0].querySelector('.accordion-header').focus();
            break;
        case 'End':
            evt.preventDefault();
            accordionItems[accordionItems.length - 1].querySelector('.accordion-header').focus();
            break;
        default:
            break;
    }
}

function slideUp(element, duration) {
    if (!element) return; // Ensure element exists
    element.style.transition = `height ${duration}ms ease-in-out, padding ${duration}ms ease-in-out, margin ${duration}ms ease-in-out`;
    element.style.height = `${element.scrollHeight - element.offsetHeight}px`;
    element.style.paddingTop = '';
    element.style.paddingBottom = '';
    element.style.marginBottom = '0';
    element.style.overflow = 'hidden'; 
    requestAnimationFrame(() => {
        element.style.height = '0';
        element.style.paddingTop = '0';
        element.style.paddingBottom = '0';
        element.style.marginBottom = '0';
    });
    setTimeout(() => {
        element.style.display = 'none';
        element.style.height = '';
        element.style.paddingTop = '';
        element.style.paddingBottom = '';
        element.style.marginBottom = '';
        element.style.transition = '';
        element.style.overflow = ''; 
    }, duration);
}

function slideDown(element, duration) {
    if (!element) return; // Ensure element exists
    element.style.display = 'block'; // Set display to block for height calculation
    const height = `${element.offsetHeight}px`;
    element.style.height = '0';
    element.style.paddingTop = '0';
    element.style.paddingBottom = '0';
    element.style.marginBottom = '';
    element.style.overflow = 'hidden'; 
    requestAnimationFrame(() => {
        element.style.transition = `height ${duration}ms ease-in-out, padding ${duration}ms ease-in-out, margin ${duration}ms ease-in-out`;
        element.style.height = height;
        element.style.paddingTop = '10px';
        element.style.paddingBottom = '32px';
        element.style.marginBottom = '';
    });
    setTimeout(() => {
        element.style.display = ''; // Set display to block after animation
        element.style.transition = '';
        element.style.paddingTop = '';
        element.style.paddingBottom = '';
        element.style.overflow = ''; 
    }, duration);
}
// function slideUp(element, duration) {
//     if (!element) return; 
//     element.style.transition = `height ${duration}ms ease-in-out`;
//     element.style.height = `${element.scrollHeight}px`;
//     requestAnimationFrame(() => {
//         element.style.height = '0';
//     });
//     setTimeout(() => {
//         element.style.display = 'none';
//         element.style.height = '0';
//         element.style.transition = '';
//     }, duration);
// }

// function slideDown(element, duration) {
//     if (!element) return; 
//     element.style.display = 'block';
//     const height = element.scrollHeight;
//     element.style.height = '0';
//     setTimeout(() => {
//         element.style.overflow = 'hidden'; 
//         element.style.transition = `height ${duration}ms ease-in-out`;
//         element.style.height = `${height}px`;
//         setTimeout(() => {
//             element.style.height = '';
//             element.style.transition = '';
//         }, duration);
//     }, 1);
// }